
import { defineComponent, ref } from "vue";
import DisplayTemplate from "../components/DisplayTemplate.vue";
import Loading from "../components/Loading.vue";
import Error from "../components/Error.vue";
import { useRoute } from "vue-router";
import SDK from "@entersekt/customerauthn-sdk-web";
import { ButtonAction, InputAnswer } from "@/models/template";
import { ISetAuthenticationFactor } from "@entersekt/customerauthn-sdk-web/dist/setAuthenticationFactor/ISetAuthenticationFactor";
import { IChallenge } from "@entersekt/customerauthn-sdk-web/dist/challengeCustomer/IChallenge";
import { INotify } from "@entersekt/customerauthn-sdk-web/dist/notify/INotify";
import { ICustomerAuthnConfig } from "@entersekt/customerauthn-sdk-web/dist/ICustomerAuthnConfig";

export default defineComponent({
  name: "Home",
  components: { DisplayTemplate, Loading, Error },

  setup() {
    const route = useRoute();
    const _channelID = route.params.channelID;
    _channelID;
    const pathCode = route.params.joinCode;
    const queryCode = route.query.code?.toString();

    const code = pathCode ? pathCode : queryCode;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const template = ref<any>(null);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const interaction = ref<any>(null);
    const error = ref<string>("");

    if (!code) {
      error.value = "No Code Provided";
      return { error };
    }

    const buttonCmd = (buttonRole: ButtonAction, inputs?: InputAnswer[]) => {
      console.log(buttonRole, inputs);
      if (buttonRole === "CONTINUE") {
        template.value = null;
        interaction.value.proceed(inputs);
      } else if (buttonRole === "CANCEL") {
        template.value = null;
        interaction.value.cancel();
      }
    };

    const config: ICustomerAuthnConfig = {
      connectionURL: process.env.VUE_APP_SOCKET_CONNECTION_URL,
      channelID: "EHS",
      timeoutInMilliseconds: 10000,
    };

    SDK.init(config).then((sdk) => {
      sdk
        .onSetAuthenticationFactor()
        .subscribe((result: ISetAuthenticationFactor) => {
          interaction.value = result;
          template.value = result.uiContent;
        });

      sdk.onChallengeCustomer().subscribe((result: IChallenge) => {
        interaction.value = result;
        template.value = result.uiContent;
      });

      sdk.onNotify().subscribe((result: INotify) => {
        interaction.value = result;
        template.value = result.uiContent;
      });

      sdk.joinInteraction(code as string).then(() => {
        console.log("joined");
      });
    });

    return { template, error, buttonCmd };
  },
});
